<template>
	<ul class="p-0 justify-content-end">
		<li>{{ systemName }}</li>
		<div class="divide" />
		<el-tooltip popper-class="session-tooltip" effect="light" :offset="10" placement="bottom-end" :manual="opened" :value="opened">
			<div slot="content">
				<span :class="{ 'session-tooltip__alarm': opened }">{{ `Session Time: ${remainingTime_(sessionCounter)}` }}</span>
				<sf-button v-if="opened" line size="sm" color="error" class="session-tooltip__btn" :onClick="resetSession">{{
					getMessage_('SWCC000909')
				}}</sf-button>
			</div>
			<li @click="toggleUserSide">
				<i class="sf-icon icon-sf-human"></i>
				<span>{{ userName }}</span>
			</li>
		</el-tooltip>

		<template v-if="menuType === 'C'">
			<div class="divide" />
			<!-- 다국어: 즐겨찾기 -->
			<li @click="openFavorites">{{ getMessage_('SWCC000439') }}</li>
			<favorites-modal :opened="favoritesModalOpened" @closed="closeFavorites" @openScreen="openScreen" />
		</template>

		<template v-if="useSitemap">
			<div class="divide" />
			<!-- 다국어: 사이트맵 -->
			<li @click="openSitemap">{{ getMessage_('SWCC000438') }}</li>
		</template>
		<div class="divide" />
		<!-- 다국어: 로그아웃 -->
		<li @click="logout">{{ getMessage_('SWCC000411') }}</li>
	</ul>
</template>

<script>
//Header 영역의 우측 Component
import { rootComputed, rootMethods } from '@/store/common/helpers';
import FavoritesModal from '../Modal/FavoritesModal';

export default {
	components: { FavoritesModal },

	props: {
		//헤더가 존재하는 Layout의 타입
		menuType: {
			type: String,
			default: ''
		},

		//사용자 이름
		userName: {
			type: String,
			default: ''
		},

		//사이트맵 사용 여부
		useSitemap: {
			type: Boolean,
			default: false
		},

		//즐겨찾기 사용 여부
		showFavorite: {
			type: Boolean,
			default: false
		},

		//사용자 설정 사이드 바 토클 매서드
		toggleUserSide: {
			type: Function
		},

		sitemapItem: null //사이트맵 화면 정보
	},

	data() {
		return {
			//즐겨찾기 창 열림/닫힘 여부
			favoritesModalOpened: false
		};
	},

	computed: {
		...rootComputed,

		opened() {
			//세션 카운트 시간이 알림 기준 시간보다 적을 경우
			return this.sessionCounter <= this.sessionAlarmTime && this.sessionState;
		},

		systemName() {
			return process.env.VUE_APP_SYSTEM_NAME;
		}
	},

	methods: {
		...rootMethods,

		//사이트맵 클릭시
		openSitemap() {
			this.$emit('sitemapClick'); //이벤트 HeaderLayout으로 사이드맵 정보와 함께 이벤트 전달
		},

		//즐겨찾기 클릭시
		openFavorites() {
			this.favoritesModalOpened = true; //즐겨찾기 팝업창 열림으로 변경
		},

		//즐겨찾기 팝업에서 닫기 버튼 클릭시
		closeFavorites() {
			this.favoritesModalOpened = false; //즐겨찾기 팝업창 닫힘으로 변경
		},

		//즐겨찾기 화면 열기
		openScreen({ item }) {
			this.$emit('openScreen', { item }); //화면 오픈 이벤트 호출
		},

		//세션 연장 기능
		resetSession() {
			this.defaultAssign_({ key: 'sessionCounter', value: this.sessionTimeout }); //세션 초기화까지 남은 시간 Reset하는 Action 호출(86400: 24시간)
		},

		//로그아웃 클릭시
		logout() {
			this.$sf_toggleLoading(true);

			//사용자 로그아웃 Action 호출
			this.logout_()
				.then(header => {
					//로그아웃 성공 시
					if (header.code === 0) {
						this.$sf_removeAll();
					} else {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
					this.$router.push('/login').catch(() => {}); //로그인 페이지로 이동
				});
		}
	}
};
</script>

<style></style>
